import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const ManufacturerCount = ({ count }) => {
  const suffix = count === 1 ? '' : 's';
  return (
    <Typography variant="caption" sx={{
      color: "text.secondary"
    }}>
      {count}manufacturer{suffix}
    </Typography>
  );
};

ManufacturerCount.propTypes = {
  count: PropTypes.number.isRequired
};

export default ManufacturerCount;